define([
	"jquery",
	"wcs.product-views",
	"domReady",
	"wcs.utils",
	"wcs.net",
	"wcs.alert",
	"shared.main.plugins",
	"shared.main.screen",
	"datalayer.wcs.video-player-events",
	"wcs.product-context",
	"foundation.core",
	"foundation.reveal",
    "shared.lazyload",
    "shared.wheretogetit",
	"promise!wcs.lang-msg",
	"coremetrics.wcs.product-detail",
	"molecules.mol-media-gallery",
	"molecules.mol-accordion",
	"datalayer.wcs.product-form"
], function($, pdpView, domReady, utils, net, alertIndicator, pluginLoader, screenSize, videoPlayerEvents){

		var DEBUG = false;

		var renderPowerReviewTemplate = WCS_CONFIG.get('PDP::pdpRenderPowerReviewTemplate');

		var productDetailsDomEventBindings = function () {

	    	if ( DEBUG ) console.log('productDetailsDomEventBindings');

			$(document).on('open.zf.reveal', '#notify-me-modal', handleNotifyMeModalEvent);

			if (WCS_CONFIG.get('PDP::pdpFittingInfoOpenAccordion')) {
				$('.product-content-form-step-label-info-link-js').on('click', handleAccordionOpenOnSizeInformationClick );
			}

			if (WCS_CONFIG.get('PDP::pdpDeliveryInformationOpenAccordion')) {
				$('.delivery-information a').on('click', handleAccordionOpenOnDeliveryInformationClick );
			} else {
				$('.delivery-information').on('click', handleDeliveryInformationClick );
			}

			$('body').on('click', '.pr-snippet-write-first-review .pr-snippet-link, .pr-snippet-write-review .pr-snippet-link, .pr-write-review-link', handlePRReviewsClick );

			videoPlayerEvents.track({
				videoElementSelector: 'video.mol-video-player',
				event: 'loadEventData',
				eventCategory: 'PDP',
				eventAction: 'Product Video'
			});
			videoPlayerEvents.track({
				videoElementSelector: '#product-tech-container video',
				fullscreenElementSelector: '#product-tech-container .video-js',
				event: 'loadEventData',
				eventCategory: 'PDP',
				eventAction: 'Product Feature Video'
			});
	    };

		var populateProductDetailsDrawer = function() {

			if ( DEBUG ) console.log('populateProductDetailsDrawer');

			var $container 		= $('.drawer-description-content-list-js'),
				data 			= $container.attr('data-list-content') || '',
				delimiter 		= WCS_CONFIG.PDP.productDescriptionListDelimiter,
				dataArray 		= data.split(delimiter),
				dataIsPresent 	= dataArray.length > 0 && dataArray[0] !== '',
				$item,
				$list 			= $('<' + WCS_CONFIG.PDP.productDescriptionListContainerTag + '>');

			if (dataIsPresent) {
				for (i = 0; i < dataArray.length; i++) {
					$item = $('<' + WCS_CONFIG.PDP.productDescriptionListItemTag + '>');

					$item.html(dataArray[i]);
					$list.append($item);
				}

				$container
					.append($list)
					.removeClass('hidden');
			}
		};

		// Toggle product details drawer accordion
		var toggleProductDetailsDrawerAccordion = (function () {

			if ( DEBUG ) console.log('toggleProductDetailsDrawerAccordion');

			var self = {};
			self.open = function (elm) {
				var $element = $(elm);
				var $productDetailsDrawerAccordion = $element.parent().siblings('.accordion-drawer-content');
				$productDetailsDrawerAccordion.slideToggle('slow');
				$element.parent().parent().toggleClass('collapsed');
			};
			self.enableClicking = function() {
				$('.accordion-close-btn-js').on('click', function() {
					toggleProductDetailsDrawerAccordion.open(this);
				});
			};
			return self;
		})();

		// Toggle individual product feature
		var toggleProductFeature = ( function() {

			if ( DEBUG ) console.log('toggleProductFeature');

			var self = {};
			self.open = function(elm) {
				var $element = $(elm).closest('ul.feature .product-feature-js');
				$element.find('.show-more-separator, .show-more, .flex-video').fadeToggle();
			};
			self.enableClicking = function() {
				$('.product-feature-button-js').on('click', function() {
					toggleProductFeature.open(this);
				});
			};
			return self;
		}());

		// Toggle product features
		var toggleProductFeatures = ( function() {

			if ( DEBUG ) console.log('toggleProductFeatures');

			var self = {};
			self.open = function(elm) {
				var $element = $(elm).closest('ul.feature');
				$element.find('.more-features-js').slideToggle("slow", function(){
					$('.show-more-features-js').fadeOut();
				});
			};
			self.enableClicking = function() {
				$('.show-more-features-js').on('click', function() {
					toggleProductFeatures.open(this);
				});
			};
			return self;
		}());

	    function toggleText($target) {

			if ( DEBUG ) console.log('toggleText');

	        var altText = $target.data('alt-text');
	        $target.data('alt-text', $target.text()).text(altText);
	    }

		function openDetailsDrawer() {

			if ( DEBUG ) console.log('openDetailsDrawer');

			$('.product-details-drawer-js').show();
			toggleText( $('.product-details-drawer-button-js'));
		}

		function handleAccordionExpansion() {
			$(".pdp-details-restructure-description .desc-container .desc-inner-container").each(function () {
			  var $this = $(this);
			  var $parent = $this.closest(".pdp-details-desc-container");
			  var $viewMore = $parent.find(".view-more");
			  var content = $this.text();
			  var charecterCount = 175; // Could be configured based on Brand preference
			  if (content.length > charecterCount) {
				var truncatedContent = content.substring(0, charecterCount) + "...";
				$this.text(truncatedContent);
				$this.attr("data-long-text", content);
				$this.attr("data-short-text", truncatedContent);
				$viewMore.removeClass("hide");
			  }
			});

			$(".pdp-details-restructure-description .desc-container .view-more, .desc-container .view-less").click(function () {
				var $this = $(this),
				  $descContainer = $this
					.closest(".pdp-details-desc-container")
					.find(".desc-inner-container"),
				  dataTextName,
				  siblingClass;
				if ($this.hasClass("view-less")) {
				  dataTextName = "data-short-text";
				  siblingClass = ".view-more";
				} else {
				  dataTextName = "data-long-text";
				  siblingClass = ".view-less";
				}
				$descContainer.text($descContainer.attr(dataTextName));
				$this.addClass("hide");
				$this.siblings(siblingClass).removeClass("hide");
			  }
			);
			handleDetailAccordionExpansion();
			handlePointsAccordion();
		  }

		  function handleDetailAccordionExpansion() {
			var $this = $(".pdp-details-container .details-row-container");
			var $parent = $this.closest(".details-body");
			var $viewMore = $parent.find(".view-more");
			var $viewLess = $parent.find(".view-less");

			var requiedHeight = 50; // Could be configured based on Brand preference
			// Check if the inner height is more than 50px
			if ($this.innerHeight() > requiedHeight) {
			  // Show "View More" link
			  $viewMore.removeClass("hide");
			  // Hide the extra content initially
			  $this.addClass("collapsed");
			}
			// Handle "View More" click
			$viewMore.click(function () {
			  $this.removeClass("collapsed");
			  $viewMore.addClass("hide");
			  $viewLess.removeClass("hide");
			});
			// Handle "View Less" click
			$viewLess.click(function () {
			  $this.addClass("collapsed");
			  $viewMore.removeClass("hide");
			  $viewLess.addClass("hide");
			});
		  }

		  function handlePointsAccordion() {
			var $this = $(".swatches-product-details .pdp-details-restructure-whats-new");
			if($this.length) {
				var $parent = $this.find("ul");
				var $viewMore = $this.find(".view-more");
				var $viewLess = $this.find(".view-less");
				var childrenCount = $parent.children().length;
				var requiredPoints = 3; //No. of points (li) to be desplayed
				var totalHeight = 0;
				$parent.children().each(function(index){
				   if(index < requiredPoints){
					totalHeight += $(this).outerHeight(true);
				   }
				});
				// Check if the <li> tags more than requiredPoints
				if (childrenCount > requiredPoints) {
					// Show "View More" link
					$viewMore.removeClass("hide");
					$parent.css("height",totalHeight+"px");
				}
				// Handle "View More" click
				$viewMore.click(function () {
					$parent.css("height","auto");
					$viewMore.addClass("hide");
					$viewLess.removeClass("hide");
				});
				// Handle "View Less" click
				$viewLess.click(function () {
					$parent.css("height",totalHeight+"px");
					$viewMore.removeClass("hide");
					$viewLess.addClass("hide");
				});
			}
		}

		function handleDeliveryInformationClick ( event ) {
			var $shippingPopUp = $('.shipping-popup');
			$shippingPopUp.addClass('medium');
			$shippingPopUp.foundation('open');
		}

		function openAccordion (accordionContainerId) {
			var $accordionContainer = $('#' + accordionContainerId);

			if ($accordionContainer) {
				if ($accordionContainer.hasClass('mol-accordion--collapsed')) {
					$accordionContainer.find('.mol-accordion__header').trigger('click');
				}
				setTimeout(function() {
					$('html, body').animate({
						scrollTop: $accordionContainer.offset().top - $accordionContainer.outerHeight()
					}, 500);
				}, 100);
			}
		}

		function handleAccordionOpenOnSizeInformationClick ( event ) {
			event.preventDefault();

			var accordionContainerId = $(event.target).data('target');
			openAccordion(accordionContainerId);
		}

		function handleAccordionOpenOnDeliveryInformationClick ( event ) {
			event.preventDefault();

			var accordionContainerId = $(event.target).closest('.delivery-information').data('targetAccordion');
			openAccordion(accordionContainerId);
		}

		function handlePRReviewsClick ( event ) {
			event.preventDefault();
			var url 			= $(this).attr('href'),
				productTitle 	= $('.product-info-title-js').text(),
				settings 		= 'width=1040,' +
						   		  'height=680,' +
						   		  'resizable=yes,' +
						   		  'scrollbars=yes,' +
						   		  'location=no,' +
						   		  'status=no,' +
						   		  'menubar=no';

			window.open(url, productTitle, settings);
		}

		function handleNotifyMeModalEvent () {
			var $modal = $(this);
			var $form = $modal.find('.notify-me-form');

			$form.on('submit', function (event) {
	        	event.preventDefault();
	        	if($form.valid()){
					var $size = $form.find('#notify-me-SIZE');
					$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.NOTIFYME.SUBMIT', [$size.val()] );
	        		net.submitForm('.notify-me-form-js').done(function(data){
	        			$('#notify-me-modal').foundation('close');
				  		$('.notify-me-response-js').removeClass('error').addClass('message success').html(data.message);
	        	    }).fail(function(jqXHR, textStatus){
	        	    	$('#notify-me-modal').foundation('close');
				  		$('.notify-me-response-js').removeClass('success').addClass('message error').html(LANG_MSG.GENERIC_ERROR_MESSAGE);
	        	    });
	        	}
			});
		}

		function initOlaPicWidget () {
			var elementId 		= "olapic_specific_widget",
                customer_id 	= OLAPIC_SETTINGS.CUSTOMER_ID,
                tags 			= $('.product-form-js').attr('data-olapic-partnumber'),
                widget_config 	= OLAPIC_SETTINGS.CAROUSEL_WIDGET_ID,
                tag_based 		= true,
                cat_based 		= false,
                collection 		= false,
                Olapic_ob 		= document.createElement("script"),
                canonicalUrl 	= "",
                url = canonicalUrl === "" ? document.domain+document.location.pathname : canonicalUrl;

            Olapic_ob.async = true;
            Olapic_ob.type 	= "text/javascript";
            Olapic_ob.src 	= encodeURI("http://widgets.photorank.me/automator?e="+elementId+"&customer_id="+customer_id+"&url="+encodeURIComponent(url)+"&title="+encodeURIComponent(document.title)+"&widget="+widget_config+"&tags="+tags+"&tag_based="+tag_based+"&cat_based="+cat_based+"&collection="+collection);
            (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(Olapic_ob);
		}

		function configureBloomreachProductCompare($el) {

			// set visibility on bloomreach heading based on results
			var $bloomReachWidget = $el.find('.br-sf-widget'),
				$bloomReachHeading = $el.find('.br-found-heading');

			if( $bloomReachWidget.length){
				$bloomReachHeading.removeClass('hide');
			} else {
				$bloomReachHeading.addClass('hide');
			}
		}

		function handleModalAnimatiom () {
			var $modalDetailsLayer = $("#modal-baselayer, #modal-cushion, #difference-learn-more");
			if($modalDetailsLayer.hasClass("active-modal")) {
				$modalDetailsLayer.parent().addClass('active-close')
				$modalDetailsLayer.removeClass("active-modal no-animate").addClass('active-modal-close')
				$modalDetailsLayer.parent().removeClass('fade-in').addClass('fade-out')
				setTimeout(function(){
					$modalDetailsLayer.parent().removeClass('active-close')
					$modalDetailsLayer.removeClass('active-modal-close')
				},400);

			}
		}

		domReady(function() {

			if (WCS_CONFIG.PDP.pdpEnablePerformanceMarks) {
				performance.mark("PDP DOM ready");
			}
			productDetailsDomEventBindings();

			pdpView.setupPDP();
			pdpView.handleContextChangePDP();
			populateProductDetailsDrawer();

			toggleProductDetailsDrawerAccordion.enableClicking();
			openDetailsDrawer();
			if(WCS_CONFIG.get('PDP::pdpCtaControlsMoreLessEnabled')) {
				handleAccordionExpansion();
			}

			$(document).on("click","#modal-baselayer .close-button, #modal-cushion .close-button, .pdp-details-close",function(e) {
				e.preventDefault();
				$('html').removeClass('is-reveal-open');
				handleModalAnimatiom();
			});

			$(document).on("click",".reveal-overlay",function(e) {
				if($(e.target).hasClass("reveal-overlay")){
					e.preventDefault();
					document.body.style.overflow = 'auto';
					handleModalAnimatiom();
				}
			});

			$(document).on('open.zf.reveal', function(e) {
				if(e.target.id === "modal-baselayer" || e.target.id === "modal-cushion" || e.target.id === "difference-learn-more") {
					$(e.target).addClass("active-modal").removeClass("no-animate");
					$(e.target).parent().removeClass('fade-out').addClass('fade-in');
					if (screenSize.size() === "small") {
						setTimeout (function() {
						$(e.target).addClass('no-animate');
						}, 500)
					}
				}
			});

			//olapic carousel widget Instantiate
			if( typeof OLAPIC_SETTINGS !== "undefined" && OLAPIC_SETTINGS.SHOW_CAROUSEL === "true" ) {
				initOlaPicWidget();
			}

            // trigger click see more link on Features section PDP drawer
            utils.seeMoreLessToggle($('.expand-features-js'), $('.drawer-features-container'));

	 		//start bloomreach search widget
	 		if (WCS_CONFIG.get('PDP::isBloomReachPdpEnabled') && WCS_CONFIG.get('global::isBloomReachMoreLinkEnabled')) {
				utils.showSearchWidgetMoreLink();
			}
	 		//end bloomreach search widget

	        var action = utils.getParamFromHash("action");
	        if ( action == "findInStore" ) {
	        	$(".find-store-js").trigger('click');
	        }

			//Blank space are present in the initial loading
			//if blank spaces are removed this code can be deleted
			var promoMessage = $('.product-promo-excluded-message');
			promoMessage.text(promoMessage.text().trim());

            if(renderPowerReviewTemplate) {
				var $powerReviewsContainer = $('.power-reviews-service-js');
				if ($powerReviewsContainer.length > 0) {
				    var powerReviewsService = $powerReviewsContainer.powerReviewsService().data().powerReviewsService;
				    powerReviewsService.initPowerReviews({
						fullview: null,
						ReviewSnippet: 'power-reviews-snippet-rating',
						SizeFitSnippet: 'pr-size-fit-snippet'
					});
				}
			}

			// load additional plugins
			pluginLoader.loadPlugins([
				{
					// Bloomreach Product Compare
					name: 'bloomreach-product-compare',
					selector: '.br_search_widget',
					initFunction: 'bloomreachProductCompare',
					callback: configureBloomreachProductCompare
				}
			]);
			if (WCS_CONFIG.PDP.pdpEnablePerformanceMarks) {
				performance.mark("PDP Init Done");
			}
		}); // end domReady

// start close define wrapper
	}
);
// dend clost define wrapper
